<template>
  <ul class="list-unstyled brand-links small mb-0 d-flex flex-column flex-md-row text-center">
    <li v-for="([href, text]) in links" :key="href">
      <a :href="href">{{ text }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    /**
     * A two-dimensional array of links, with each item an array containing the
     * URL and display text of the link.
     */
    links: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.brand-links {
  @include media-breakpoint-down(md) {
    li {
      padding-bottom: 0.5em;
      padding-top: 0.5em;

      &:not(:last-child) {
        border-bottom: 1px solid $primary-light;
      }
    }
  }

  @include media-breakpoint-up(md) {
    li:not(:last-child):after {
      content: "";
      border-left: 1px solid $primary-light;
      margin-left: 0.5em;
      margin-right: 0.5em;
    }
  }

  a:not(:hover) { text-decoration: none; }

  li { white-space: nowrap; }
}
</style>
